import "./MessageDialog.scss";
import { FunctionComponent, useEffect, useState } from "react";
import { MessageDialogProps } from "./IMessageDialog";
import Dialog from "../Dialog/Dialog";
import IconButtonField from "../Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import { ReactComponent as Cancel } from "../../Assets/Images/Cancel.svg";
import ButtonField from "../Button/ButtonField";
import { ReactComponent as Success } from "../../Assets/Images/success.svg";
import { ReactComponent as Failure } from "../../Assets/Images/failure.svg";
import ResponseDialog from "../ResponseDialog/ResponseDialog";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listExamsubmit } from "../../Redux/Slices/ExamAnswer/ListExamsubmitSlice";
import { listExamsubmitPractice } from "../../Redux/Slices/ExamAnswerPractice/ListExamsubmitPracticeSlice";
import { listEvaluationPracticewritingExam } from "../../Redux/Slices/PracticeExam/ListEvaluationPracticewritingExamSlice";
import { addCloseSection } from "../../Redux/Slices/Exam/AddCloseSectionSlice";
import { listEvaluation } from "../../Redux/Slices/Exam/ListEvaluationSlice";

const MessageDialog: FunctionComponent<MessageDialogProps> = (props) => {
  const {
    open,
    setOpen,
    messageableName,
    messageheading,
    valueofdata,
    condition,
    writingSentence,
    Question_id,
    exam_id,
    setIsSubmitted,
    student_exam_id,
    remaining_time,
    question_type_id,
  } = props;
  const [responseDialog, setResponseDialog] = useState<boolean>(false);
  const handleClose = () => {
    setOpen(false);
    setResponseDialog(false);
  };
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const final: any = valueofdata;

  const { data: listExamsubmitSlice } = useAppSelector(
    (state) => state.ListExamsubmitSlice
  );
  const Add: any = listExamsubmitSlice?.data;

      const now = new Date();
    const pad = (n:any) => String(n).padStart(2, "0");

    const timestamp =
      `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}` +
      `T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(
        now.getSeconds()
      )}`;


  return (
    <>
      <Dialog
        open={open}
        dialogClassName="message_dialog"
        dialogTitleClassName="message_dialog_title"
        Dialog_Title={<>{messageheading}</>}
        dialogContentClassName="message_dialog_content"
        Dialog_Content={<>{messageableName}</>}
        dialogActionClassName="message_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={() => {
                setOpen(false);
                setIsSubmitted && setIsSubmitted(false);
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="message_button"
              onClick={() => {
                dispatch(listExamsubmit({ id: final
                  // end_time : timestamp}));
                }));
                dispatch(
                  listEvaluation({
                    student_exam_id: Add?.student_exam_id,
                  })
                );
                dispatch(
                  addCloseSection({
                    student_exam_id: final,
                    remaining_time: remaining_time,
                    closed: true,
                    question_type_id: question_type_id,
                  })
                );

                setIsSubmitted && setIsSubmitted(false);
                navigate("/examresult", {
                  state: {
                    id: final,
                    showSubmitAlert: true, // ✅ Add this line
                  },
                }); // Replace with your target route
              }}
            >
              Submit
            </ButtonField>
          </>
        }
      />
    </>
  );
};

export default MessageDialog;
